module.exports = __webpack_public_path__ + "assets/icon-card-green.4a43aa20.svg";